import React, { FunctionComponent } from "react";
import { DashboardEditorProps } from "components/ComponentTypeTypes";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { T } from "services/lang/LanguageService";
import { ISeparatorProps } from "./SeparatorTypes";

function SeparatorEditor({ config, onConfigChange }: DashboardEditorProps<ISeparatorProps>) {
  const conf = config ?? {};
  const handleConfigChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    conf.title = e.target.value;
    onConfigChange(conf);
  };

  return (
    <div className="flex flex-column gap-2">
      <div className="flex flex-column gap-2">
        <label htmlFor="displayDweenLine">{T("action.display-dween-line")}</label>
        <InputSwitch
          id="displayDweenLine"
          checked={conf.displayDweenLine ?? false}
          onChange={e => onConfigChange({ ...conf, displayDweenLine: e.value })}
        />
      </div>
      {!conf.displayDweenLine && (
        <div className="flex flex-column gap-2">
          <label htmlFor="title">{T("word.title")}</label>
          <InputText autoFocus id="title" type="text" value={conf.title} onChange={handleConfigChange} />
        </div>
      )}
    </div>
  );
}

export default SeparatorEditor as FunctionComponent;
